module.exports = __webpack_public_path__ + "static/media/TW-AFLDraft-2019-desktop-1220x150.7696f120.jpg";